module.exports = __webpack_public_path__ + "assets/img/qrcode_ms.2171f073.jpg";